import { RumInitConfiguration, datadogRum } from '@datadog/browser-rum'

export const initDatadogRum = ({
  applicationId,
  clientToken,
  version,
  env,
}: Pick<
  RumInitConfiguration,
  'applicationId' | 'clientToken' | 'version' | 'env'
>) => {
  datadogRum.init({
    applicationId,
    clientToken,
    version: `web-app@${version}`,
    trackUserInteractions: true,
    trackResources: true,
    service: 'web-app',
    env,
    allowedTracingUrls: [/.*graphql.*/],
  })
}
